/**
 * Get the token from the store.
 *
 * @param {Object} socket The current state of the socket in the store.
 *
 * @returns {Object} An object with the socket.
 */
const mapStateToProps = ({ socket }) => ({ token: socket.token });

export default [mapStateToProps];
